import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import About from "./About";
import { ButtonContact } from "../components/ButtonContact";
import { Skills } from "./Skills";
import { Projects } from "./Projects";
import { Come_on } from "./Come_on";
import { Footer } from "../components/Footer";

export const Main = () => {
  const [showEntrance, setShowEntrance] = useState(false);

  useEffect(() => {
    setShowEntrance(true);
  }, []);

  return (
    <div
      className={`${
        showEntrance
          ? "tw-animate-slideInLeft tw-overflow-x-hidden"
          : "tw-divide-y-2"
      }`}
    >
      <Header />
      <About />
      <div className="tw-w-full tw-h-[1px] tw-bg-[#D0E8F4]"></div>
      <Skills />
      <div className="tw-w-full tw-h-[1px] tw-bg-[#D0E8F4]"></div>
      <Projects />
      <div className="tw-w-full tw-h-[1px] tw-bg-[#D0E8F4]"></div>
      <Come_on />
      <div className="tw-w-full tw-h-[1px] tw-bg-[#D0E8F4]"></div>
      <Footer />

      <ButtonContact />
    </div>
  );
};
